import React from "react";
import { Typography, Breadcrumb } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../redux/store";

/** The page's breadcrumb and title from the layout header, shared by Header and MobileNav. */
export const PageHeading: React.FC = () => {
  const { header } = useAppSelector((state) => state.layout);
  const navigate = useNavigate();

  return (
    <>
      {header.navigations.length > 0 ? (
        <Breadcrumb
          separator={<RightOutlined style={{ fontSize: 9 }} />}
          items={header.navigations.map((nav) => ({
            title: nav.title,
            onClick: () => nav.url && navigate(nav.url),
            href: nav.url,
          }))}
          itemRender={(route) => {
            if (route.href) {
              return <Link to={route.href}>{route.title}</Link>;
            }
            // The current item is often a stream name: cut it by width, full name in the tooltip
            return (
              <Typography.Text ellipsis={{ tooltip: route.title }}>{route.title}</Typography.Text>
            );
          }}
        />
      ) : null}
      {/* Our titles are short Dela copy and may wrap; a stream name is Rubik on one line. */}
      {header.title ? (
        <Typography.Title
          level={1}
          className={header.userContent ? "st-title--user" : undefined}
          style={{ margin: 0 }}
          ellipsis={header.userContent ? { tooltip: header.title } : false}
        >
          {header.title}
        </Typography.Title>
      ) : null}
    </>
  );
};
